import { supabase } from '../lib/supabase';

export const schoolService = {
  async getAllSchools(city = null) {
    let query = supabase?.from('schools')?.select('*')?.eq('is_active', true)?.order('name', { ascending: true });

    if (city) {
      query = query?.eq('city', city);
    }

    const { data, error } = await query;

    if (error) throw error;
    return data || [];
  },

  async getSchoolById(schoolId) {
    const { data, error } = await supabase?.from('schools')?.select('*')?.eq('id', schoolId)?.single();

    if (error) throw error;
    return data;
  },

  async createSchool(schoolData) {
    const { data, error } = await supabase?.from('schools')?.insert({
        name: schoolData?.name,
        city: schoolData?.city,
        address: schoolData?.address,
        email: schoolData?.email,
        phone: schoolData?.phone
      })?.select()?.single();

    if (error) throw error;
    return data;
  },

  async updateSchool(schoolId, updates) {
    const { data, error } = await supabase?.from('schools')?.update(updates)?.eq('id', schoolId)?.select()?.single();

    if (error) throw error;
    return data;
  },

  async searchSchools(searchTerm, city = null, limit = 20) {
    if (!searchTerm || searchTerm.trim().length < 2) {
      return []; // Require at least 2 characters
    }

    let query = supabase
      ?.from('schools')
      ?.select('id, name, city')
      ?.eq('is_active', true)
      ?.ilike('name', `%${searchTerm.trim()}%`)
      ?.order('name', { ascending: true })
      ?.limit(limit);

    if (city && city !== 'all') {
      query = query?.eq('city', city);
    }

    const { data, error } = await query;

    if (error) throw error;
    return data || [];
  }
};